import { render } from "./Spinner.vue?vue&type=template&id=d4dcf858&scoped=true"
const script = {}

import "./Spinner.vue?vue&type=style&index=0&id=d4dcf858&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d4dcf858"

export default script